import React from 'react';
import { motion } from 'framer-motion';
import { useGameStore } from '@/store/gameStore';

const EvalBar = () => {
  const { evaluation, coachEnabled, boardTheme } = useGameStore();
  
  if (!coachEnabled) return null;
  
  // Normalize evaluation to percentage (clamp between -10 and 10, then scale to 0-100)
  const normalizedEval = Math.max(-1000, Math.min(1000, evaluation));
  const percentage = 50 + (normalizedEval / 1000) * 50;
  
  const displayEval = Math.abs(evaluation) >= 10000 
    ? (evaluation > 0 ? 'M' : '-M') 
    : (evaluation / 100).toFixed(1);
  
  return (
    <div className="flex flex-col items-center gap-2" data-testid="eval-bar">
      <span className="text-xs text-gray-400 uppercase tracking-wider">Evaluation</span>
      
      <div className={`
        relative w-8 h-48 rounded-full overflow-hidden
        ${boardTheme === 'cosmic' 
          ? 'bg-slate-800 border border-purple-500/30' 
          : 'bg-gray-300 border border-gray-400'
        }
      `}>
        {/* White (bottom) */}
        <motion.div
          className={`
            absolute bottom-0 left-0 right-0
            ${boardTheme === 'cosmic' 
              ? 'bg-gradient-to-t from-white to-gray-200' 
              : 'bg-white'
            }
          `}
          initial={{ height: '50%' }}
          animate={{ height: `${percentage}%` }}
          transition={{ duration: 0.5, ease: 'easeOut' }}
        />
        
        {/* Center line */}
        <div className="absolute top-1/2 left-0 right-0 h-0.5 bg-gray-500/50 -translate-y-0.5" />
        
        {/* Evaluation number */}
        <div className={`
          absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2
          text-xs font-bold px-1 py-0.5 rounded
          ${evaluation >= 0 
            ? 'bg-white text-black' 
            : 'bg-slate-900 text-white'
          }
        `}>
          {evaluation >= 0 ? '+' : ''}{displayEval}
        </div>
      </div>
      
      <div className="flex flex-col items-center text-xs">
        <span className="text-gray-300">White</span>
        <span className={`font-bold ${evaluation >= 0 ? 'text-green-400' : 'text-red-400'}`}>
          {evaluation >= 0 ? 'Better' : 'Worse'}
        </span>
      </div>
    </div>
  );
};

export default EvalBar;
